<app-modal-header (closeModal)="cancel()"> </app-modal-header>
<app-modal-body class="text-center">
  <h1 class="modal-title fs-5 text-truncate pe-2 d-flex align-items-center justify-content-center my-2">
    <i class="ri-sparkling-fill me-2"></i>
    {{ resultFound }}
  </h1>
  <p class="mb-0">{{ resultFoundDesc }}</p>
</app-modal-body>
<app-modal-footer classList="d-flex justify-content-center">
  <div class="d-flex gap-2">
    <button type="button" class="btn btn-primary rounded-5 fw-medium" (click)="confirm()">
      {{ 'TAKE_ME_THERE' | translate }}
    </button>
    <button
      type="button"
      class="btn rounded-5 fw-medium"
      (click)="cancel()"
      [class.btn-outline-dark]="!isBgDarkMode"
      [class.btn-outline-light]="isBgDarkMode"
    >
      {{ 'NO_STAY_CURRENT' | translate }}
    </button>
  </div>
</app-modal-footer>
